import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class FeedbackService {


    constructor(private http: HttpClient) {
    }

    onPostFeedback(data) {
        return this.http.post('/api/addFeedback', data)
    }

    onGetAllFeedback() {
        return this.http.get('/api/getAllFeedbacks')
    }

    getFeedbacksByMainId() {
        return this.http.get('/api/getFeedbacksByMainId')
    }

    getFeedbackById(id) {
        return this.http.get('/api/getFeedbackById?feedbackId=' + id);
    }

    //////////////////api endpoint delete nu merge
    // onDeleteFeedback(data){
    //   return this.http.delete('/api/deleteFeedback', data)
    // }
    onPostTest(data) {
        return this.http.post('https://reqres.in/api/register', data)
    }

    onGetUserFeedback(userId: string) {
        return this.http.get(`/upsell/getUserFeedBack?userId=${userId}`)
    }
}
